/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { get } from "lodash";
import TextField from "components/text-field/text-field";
import { Integrations, ApiKeyConfig } from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

interface Props {
  integration:
    | { key: Integrations.GoogleMaps; value: ApiKeyConfig }
    | { key: Integrations.PushEngage; value: ApiKeyConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const ApiKeyIntegration: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.api-key")}
        value={integration.value["api-key"]}
        onChange={(value) => updateIntegrationField(integrationName, { "api-key": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<ApiKeyConfig>(errors) ? get(errors, ["errors", "value", "api-key", "0"]) : undefined
        }
      />
    </React.Fragment>
  );
};

export default ApiKeyIntegration;
